import type { PayableStop } from '@festina/moneyout-general-types/moneyout'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { PayableStopText } from '../moneyOut/paymentReceiver/PayableStopText'

type Props = {
  payableStops: PayableStop[]
}

export const MoneyOutStopReasons = ({ payableStops }: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  return (
    <div>
      {payableStops.map(({ _id, payableStopType, text }) => (
        <div key={_id} className="not-last:pb-2">
          {payableStopType && (
            <p>
              {translate('moneyOut.stop.paymentType', {
                paymentType: translateEnum(
                  'moneyOut.enum.PayableStopType',
                  payableStopType,
                ),
              })}
            </p>
          )}
          {text && (
            <p>
              {translate('moneyOut.stop.description')}
              <PayableStopText textId={text} />
            </p>
          )}
        </div>
      ))}
    </div>
  )
}
